import { Second } from '@nu-art/ts-common';
const EpicAction_InitiateHandshake = 'Epic.Clinical.Informatics.Web.InitiateHandshake';
const EpicAction_OpenToTarget = 'Epic.Clinical.Informatics.Web.OpenToTarget';
const EpicAction_OpenExternalWindow = 'Epic.Clinical.Informatics.Web.OpenExternalWindow';
const EpicAction_CloseActivity = 'Epic.Clinical.Informatics.Web.CloseActivity';
const EpicAction_SaveState = 'Epic.Clinical.Informatics.Web.SaveState';
const EpicAction_PostOrder = 'Epic.Clinical.Informatics.Web.PostOrder';
const EpicAction_PostOrderByNDCID = 'Epic.Clinical.Informatics.Web.PostOrderByNDCID';
const EpicAction_PostFlowsheetRow = 'Epic.Clinical.Informatics.Web.PostFlowsheetRow';
const EpicAction_LaunchActivity = 'Epic.Clinical.Informatics.Web.LaunchActivity';
const EpicAction_BridgeConfig = 'Epic.Clinical.Informatics.Web.BridgeConfig';
const EpicAction_SetEnabledHistBtns = 'Epic.Clinical.Informatics.Web.SetEnabledHistBtns';
const EpicAction_SaveHistoryState = 'Epic.Clinical.Informatics.Web.SaveHistoryState';
const EpicAction_SetEnabledPrintBtn = 'Epic.Clinical.Informatics.Web.SetEnabledPrintBtn';
const EpicAction_OpenDefaultBrowser = 'Epic.Common.OpenDefaultBrowser';
const EpicAction_SearchDiagnosis = 'Epic.Clinical.Ambulatory.ProblemOrientedCharting.SearchDiagnosis';
const EpicAction_PostProtocol = 'Epic.Clinical.Informatics.Web.PostProtocol';
const EpicAction_AddDiagnosis = 'Epic.Clinical.Ambulatory.ProblemOrientedCharting.AddDiagnosis';
const EpicAction_ApplyActions = 'Epic.Clinical.Informatics.ApplyActions';
const EpicAction_ClearActions = 'Epic.Clinical.Informatics.ClearActions';
export const AllEpicActions = [
    'Epic.Clinical.Informatics.Web.InitiateHandshake',
    'Epic.Clinical.Informatics.Web.OpenToTarget',
    'Epic.Clinical.Informatics.Web.OpenExternalWindow',
    'Epic.Clinical.Informatics.Web.CloseActivity',
    'Epic.Clinical.Informatics.Web.SaveState',
    'Epic.Clinical.Informatics.Web.PostOrder',
    'Epic.Clinical.Informatics.Web.PostOrderByNDCID',
    'Epic.Clinical.Informatics.Web.PostFlowsheetRow',
    'Epic.Clinical.Informatics.Web.LaunchActivity',
    'Epic.Clinical.Informatics.Web.BridgeConfig',
    'Epic.Clinical.Informatics.Web.SetEnabledHistBtns',
    'Epic.Clinical.Informatics.Web.SaveHistoryState',
    'Epic.Clinical.Informatics.Web.SetEnabledPrintBtn',
    'Epic.Common.OpenDefaultBrowser',
    'Epic.Clinical.Ambulatory.ProblemOrientedCharting.SearchDiagnosis',
    'Epic.Clinical.Informatics.Web.PostProtocol',
    'Epic.Clinical.Ambulatory.ProblemOrientedCharting.AddDiagnosis',
    'Epic.Clinical.Informatics.ApplyActions',
    'Epic.Clinical.Informatics.ClearActions',
];
export const EpicRequest_InitiateHandshakeWithListener = {
    label: 'Initiate Handshake With Close listener', content: {
        'action': EpicAction_InitiateHandshake, 'args': {
            SubscriptionRequests: [{
                    EventName: 'Epic.Common.RequestToCloseApp',
                    EventArgs: { PauseDuration: 5 * Second }
                }
            ]
        }
    }
};
export const AllOrderRequestTemplates = [
    EpicRequest_InitiateHandshakeWithListener,
    { label: 'Post Order LAB0129', content: { 'token': '{{TOKEN}}', 'action': EpicAction_PostOrder, 'args': { 'OrderKey': 'LAB0129' } } },
    { label: 'Launch Activity', content: { 'token': '{{TOKEN}}', 'action': EpicAction_LaunchActivity, 'args': {} } },
    { label: 'Close Activity', content: { 'token': '{{TOKEN}}', 'action': EpicAction_CloseActivity, 'args': {} } },
    { label: 'Open To Target', content: { 'token': '{{TOKEN}}', 'action': EpicAction_OpenToTarget, 'args': {} } },
    { label: 'Open External Window', content: { 'token': '{{TOKEN}}', 'action': EpicAction_OpenExternalWindow, 'args': {} } },
    { label: 'Save State', content: { 'token': '{{TOKEN}}', 'action': EpicAction_SaveState, 'args': {} } },
    { label: 'Post Order By NDCID', content: { 'token': '{{TOKEN}}', 'action': EpicAction_PostOrderByNDCID, 'args': {} } },
    { label: 'Post Flowsheet Row', content: { 'token': '{{TOKEN}}', 'action': EpicAction_PostFlowsheetRow, 'args': {} } },
    { label: 'Bridge Config', content: { 'token': '{{TOKEN}}', 'action': EpicAction_BridgeConfig, 'args': {} } },
    { label: 'Set Enabled Hist Btns', content: { 'token': '{{TOKEN}}', 'action': EpicAction_SetEnabledHistBtns, 'args': {} } },
    { label: 'Save History State', content: { 'token': '{{TOKEN}}', 'action': EpicAction_SaveHistoryState, 'args': {} } },
    { label: 'Set Enabled Print Btn', content: { 'token': '{{TOKEN}}', 'action': EpicAction_SetEnabledPrintBtn, 'args': {} } },
    { label: 'Open Default Browser', content: { 'token': '{{TOKEN}}', 'action': EpicAction_OpenDefaultBrowser, 'args': {} } },
    { label: 'Search Diagnosis', content: { 'token': '{{TOKEN}}', 'action': EpicAction_SearchDiagnosis, 'args': {} } },
    { label: 'Post Protocol', content: { 'token': '{{TOKEN}}', 'action': EpicAction_PostProtocol, 'args': {} } },
    { label: 'Add Diagnosis', content: { 'token': '{{TOKEN}}', 'action': EpicAction_AddDiagnosis, 'args': {} } },
    { label: 'Apply Actions', content: { 'token': '{{TOKEN}}', 'action': EpicAction_ApplyActions, 'args': {} } },
    { label: 'Clear Actions', content: { 'token': '{{TOKEN}}', 'action': EpicAction_ClearActions, 'args': {} } },
];
//# sourceMappingURL=templates.js.map